@if (open) {
  <div class="modal-bg" @fadeInOut (click)="close()"></div>
  <div
    class="modal"
    [ngClass]="modalClass"
    [@modalVariant]="isPanelRight ? 'right' : 'center'"
    (click)="$event.stopPropagation()"
  >
    @if (showClose) {
      <div class="modal__close-button" (click)="close()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    }
    <div class="modal__section modal__header">
      <ng-content select="[modal-header]"></ng-content>
    </div>
    <div class="modal__image">
      <ng-content select="[modal-image]"></ng-content>
    </div>
    <div class="modal__section modal__body">
      <ng-content select="[modal-body]"></ng-content>
    </div>
    <div class="modal__section modal__footer">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
}
